import { render } from "./FileType.vue?vue&type=template&id=550c57f0"
import script from "./FileType.vue?vue&type=script&lang=js"
export * from "./FileType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__